import React, { Component, Fragment } from 'react';


class WaifuSection2 extends Component {
    state = {
        data: {},
        workData: []
    }
    componentDidMount() {

    }
    render() {
        return (

            <Fragment>
                <div id="collection" className="row waifu-section-2">
                    <div className="col-12">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 offset-md-6">
                                    <div className="waifu-section-text-container2">
                                        <div className="intro mb-4" >
                                            <div className="intro-content text-right">
                                                {/* <h3 className="mt-3 mb-0">JOIN THE DEFI MAFIA MULTIVERSE</h3> */}
                                                <h3 className="mt-3 mb-0">JOIN THE COMMUNITY</h3>
                                                <div className="waifu-section-title-separator"></div>
                                                <div className="waifu-section-text">
                                                    Our community is rapidly growing! If you want to join the #MetaWaifus it's here. Join us to get the news as soon as possible and follow our latest announcements.
                                                    {/* META WAIFUs are the first limited edition characters interoperable with the DeFi Mafia multiverse, a revolutionary play-to-earn GameFi metaverse. */}
                                                </div>
                                                <div className="button-group">
                                                    <a target="_blank" className="btn btn-bordered-white" href="https://discord.com/invite/uxG9y6Nz4k"><i className="icon-rocket mr-2"></i>Join our Discord</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

        );
    }
}

export default WaifuSection2;